import React, {useCallback, useContext, useEffect} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import ProgressBarView from '../../views/progressbarView';
import AbortSMV from './abort-smv';
import SMVComplete from './smv-complete';
import {useTranslation, withTranslation, Trans} from 'react-i18next';

function SmartMeterPB() {
  const leftPress = useKeyPress('ArrowLeft');
  const {onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onLeft = useCallback(() => {
    onComponent(<AbortSMV />);
  }, []);

  useEffect(() => {
    if (!leftPress) return;

    onComponent(<AbortSMV />);
  }, [leftPress]);

  useEffect(() => {
    onUpdateCommands({onLeft});
  }, [onLeft]);

  const {t, i18n} = useTranslation();
    const changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };

  return (
    <ProgressBarView
      title={t('smvRunVerif.a9')}
      content={t('smvRunVerif.a10')}
      onExit={() => onComponent(<SMVComplete />)}
      left={t('smvRunVerif.a11')}
    />
  );
}

export default SmartMeterPB;
